import { Component, OnDestroy, OnInit } from "@angular/core";
import { LoaderService } from "../../services/loader.service";
import { Subject, takeUntil } from "rxjs";
import { NgIf } from "@angular/common";
import { CdnClientDirective } from "../../directives/cdn-client.directive";

@Component({
    standalone: true,
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    imports: [ NgIf, CdnClientDirective ]
})
export class Loader implements OnInit, OnDestroy {
    protected isLoading: boolean = true;
    protected componentDestroyed$ = new Subject<void>();

    constructor(private readonly loaderService: LoaderService) { }

    ngOnInit(): void {
        this.loaderService.loading
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((isLoading: boolean) => {
                this.isLoading = isLoading;
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}